<div class="col-6 row">
  <div class="col-4 details-key-main">
    <div class="col-12">
      {{field.label}}
    </div>
  </div>
  <div class="col-8">
    <div class="form-group col-12 paddingzero margin-bottom-0 row">
      <div class="col-12">
        <mat-form-field class="col-12" appearance="outline" [formGroup]="group">
          <textarea matInput [formControlName]="field.name" cols="3" [placeholder]="field.placeHolder"
            [type]="field.inputType"></textarea>
          <!-- <input matInput [formControlName]="field.name" [placeholder]="field.label" [type]="field.inputType"> -->
          <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
            <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
          </ng-container>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
